<template>
  <v-dialog
    v-model="dialog_sign"
    flat
    persistent
    max-width="370"
    content-class="br_none"
  >
    <v-card class="br_none modal_comfirm_wrap type4">
      <v-btn class="modal_close" @click="fnClose()" fab color="white">
        <v-icon dark>mdi-close</v-icon>
      </v-btn>
      <h2 class="header_title02 type4">{{ $t('user.signature.fields.signature') }}</h2>
    </v-card>
    <v-layout class="login_wrap type2 modal_type">
      <v-flex class="pa-0 login_content type2 mt-0">
        <v-card class="login_form type2 type3 pt--0" flat>
          <v-card-text class="pa-0 inner_item_content bd_none">
            <v-row>
              <v-col cols="12">
                <v-radio-group
                  row
                  v-model="sign_image_type"
                  class="mt--2"
                >
                  <v-radio
                    :label="$t('user.signature.fields.upload_signature')"
                    value="file"
                  />
                  <v-radio
                    :label="$t('user.signature.fields.draw_signature')"
                    value="canvas"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row v-if="sign_image_type === 'file'">
              <v-col cols="12" class="">
                <v-form
                  v-model="valid_signature"
                  lazy-validation
                  data-vv-scope="scope_signature"
                  style="min-width:100px;"
                >
                  <div class="input_text_type_basic file_type wp100 proof__signature fileForm">
                    <v-file-input
                      dense
                      outlined
                      style="height: 40px;"
                      :placeholder="$t('common.common.no_files_selected')"
                      :prepend-icon="$t('common.common.select_file')"
                      class="ft-size12 bg-white"
                      accept=".jpg,.gif,.png"
                      v-model="signFile"
                      @change="fnChangeSignFile"
                      v-validate="{required: sign_image_type === 'file', file_rule: true}"
                      :error-messages="errors.collect('scope_signature.signFile')"
                      name="signFile"
                      :data-vv-as="$t('user.signature.title')"
                      clearable
                      @click:clear="signFile = null"
                    >
                    </v-file-input>
                  </div>
                </v-form>
                <!-- 리사이즈를 위한 캔버스 -->
                <canvas id="resize" v-show="false" width="100" height="50"></canvas>
                <!-- 이미지 크기 체크 -->
                <img id="check_img" :src="img_src" v-show="false" @load="fnCheckSize" width="100" height="50" />
              </v-col>
            </v-row>
            <v-row v-if="sign_image_type === 'canvas'">
              <v-col cols="12" class="pb-0">
                <canvas
                  id="sig-canvas"
                  width="300"
                  height="150"
                  @mousemove="draw"
                  @mousedown="beginDrawing"
                  @mouseup="stopDrawing"
                >
                </canvas>
                <!-- 리사이즈를 위한 캔버스 -->
                <canvas id="resize" v-show="false" width="100" height="50"></canvas>
              </v-col>
              <v-col cols="12">
                <v-btn
                  color="button-size-1 btn-dactv"
                  style="height: 30px !important; font-size : 12px;"
                  @click="clearCanvas"
                >
                  {{ $t('user.signature.fields.clear_signature') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="mt-10">
            <v-spacer></v-spacer>
            <v-btn
              dense
              height="50"
              width="150"
              dark
              color="#2a58ad"
              class="btn-normal br_none"
              @click="fnSave()"
            >
              {{ $t('common.button.submit') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-dialog>
</template>

<script>
import eventBus from '@/utils/eventBus'
import utils from '@/utils/utils'

export default {
  components :{
  },
  data () {
    return {
      sign_image_type: 'canvas',
      dialog_sign : false,
      canvas: null,
      canvasResize: null,
      x: 0,
      y: 0,
      isDrawing: false,
      img_src: '',
      signFile : null,
      valid_signature : true,
      signSrc: ''
    }
  },
  watch : {
    dialog_sign(val){
      if(val){
        requestAnimationFrame(() => {
          this.$nextTick(() => {
            this.signFile = null
            this.img_src = ''
            this.sign_image_type = 'canvas'

            let c = document.getElementById("sig-canvas")
            this.canvas = c.getContext('2d')
            this.canvas.clearRect(0, 0, 300, 150)

            this.canvasResize = document.getElementById('resize').getContext('2d')
            this.canvasResize.clearRect(0, 0, 150, 50)
          })
        })
      }
    }
  },
  mounted () {
  },
  methods: {
    drawLine(x1, y1, x2, y2) {
      let ctx = this.canvas;
      ctx.beginPath();
      ctx.strokeStyle = 'black';
      ctx.lineWidth = 1;
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
      ctx.stroke();
      ctx.closePath();
    },
    draw(e) {
      if(this.isDrawing) {
        this.drawLine(this.x, this.y, e.offsetX, e.offsetY)
        this.x = e.offsetX
        this.y = e.offsetY
      }
    },
    beginDrawing(e) {
      this.x = e.offsetX
      this.y = e.offsetY
      this.isDrawing = true
    },
    stopDrawing(e) {
      if (this.isDrawing) {
        this.drawLine(this.x, this.y, e.offsetX, e.offsetY)
        this.x = 0
        this.y = 0
        this.isDrawing = false
      }
    },
    fnSave(){
      let img = new Image()
      let target = this
      img.onload = function() {
        let resize = document.getElementById('resize')
        let resizeCtx = resize.getContext('2d')
        resizeCtx.drawImage(img, 0, 0, 100, 50)
        let resizeSrc = resize.toDataURL('image/jpg')

        target.$emit('success', resizeSrc)
        target.fnClose()
      }

      if (this.sign_image_type === 'canvas') {
        let ctx = document.getElementById('sig-canvas')
        let src = ctx.toDataURL('image/jpg')
        img.src = src
      } else if (this.sign_image_type === 'file') {
        this.$validator.validateAll('scope_company').then((valid) => {
          if(valid){
            img.src = this.img_src
          }
        })
      }
    },
    clearCanvas() {
      this.canvas.clearRect(0, 0, 300, 150)
      this.canvasResize.clearRect(0, 0, 150, 50)
    },
    fnClose(){
      this.dialog_sign = false
      this.sign_image_type = 'canvas'
    },
    fnCheckSize(){
      let img = document.getElementById('check_img')
      let width = img.naturalWidth
      let height = img.naturalHeight

      if(width > 100 || height > 50){
        eventBus.$emit('SHOW_SNACKBAR', { text : this.$t('user.signature.fields.upload_signature') })
        this.signFile = null
        this.img_src = ''
      }
    },
    fnChangeSignFile(){
      if(this.signFile){
        let file = this.signFile

        let extList = []
        extList.push({name_en: 'jpg'})
        extList.push({name_en: 'gif'})
        extList.push({name_en: 'png'})

        if (utils.getFileExtLen(file, extList, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            this.signFile = null
          }, 100)

          return
        }

        this.img_src = URL.createObjectURL(file)
      }
    },
  }
}
</script>

<style>
  #sig-canvas {
    border: 2px dotted #CCCCCC;
    border-radius: 15px;
    cursor: crosshair;
  }
</style>